/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HotelEarnings } from './HotelEarnings';
import {
    HotelEarningsFromJSON,
    HotelEarningsFromJSONTyped,
    HotelEarningsToJSON,
    HotelEarningsToJSONTyped,
} from './HotelEarnings';

/**
 * 
 * @export
 * @interface BookingDetails
 */
export interface BookingDetails {
    /**
     * Gondola-internal booking ID. For user-facing Gondola confirmation number, use gondola_booking_id instead.
     * @type {number}
     * @memberof BookingDetails
     */
    bookingId?: number;
    /**
     * User-facing Gondola booking confirmation number.
     * @type {string}
     * @memberof BookingDetails
     */
    gondolaBookingId?: string;
    /**
     * 
     * @type {HotelEarnings}
     * @memberof BookingDetails
     */
    hotelEarnings?: HotelEarnings;
    /**
     * the user's Loyalty ID associated with the booking'
     * @type {string}
     * @memberof BookingDetails
     */
    loyaltyId?: string;
    /**
     * True when the user redeemed Gondola Cash to pay for this booking (LiteAPI / Gondola Cash bookings). UI uses this to swap the loyalty earnings module for a 'Paid with Gondola Cash' indicator.
     * @type {boolean}
     * @memberof BookingDetails
     */
    usedGondolaCredits?: boolean;
}

/**
 * Check if a given object implements the BookingDetails interface.
 */
export function instanceOfBookingDetails(value: object): value is BookingDetails {
    return true;
}

export function BookingDetailsFromJSON(json: any): BookingDetails {
    return BookingDetailsFromJSONTyped(json, false);
}

export function BookingDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'bookingId': json['booking_id'] == null ? undefined : json['booking_id'],
        'gondolaBookingId': json['gondola_booking_id'] == null ? undefined : json['gondola_booking_id'],
        'hotelEarnings': json['hotel_earnings'] == null ? undefined : HotelEarningsFromJSON(json['hotel_earnings']),
        'loyaltyId': json['loyalty_id'] == null ? undefined : json['loyalty_id'],
        'usedGondolaCredits': json['used_gondola_credits'] == null ? undefined : json['used_gondola_credits'],
    };
}

export function BookingDetailsToJSON(json: any): BookingDetails {
    return BookingDetailsToJSONTyped(json, false);
}

export function BookingDetailsToJSONTyped(value?: BookingDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking_id': value['bookingId'],
        'gondola_booking_id': value['gondolaBookingId'],
        'hotel_earnings': HotelEarningsToJSON(value['hotelEarnings']),
        'loyalty_id': value['loyaltyId'],
        'used_gondola_credits': value['usedGondolaCredits'],
    };
}

